import { getProviderInfo } from './providerMap';

function aggregateStatusFromJobs(jobs) {
  if (!Array.isArray(jobs) || jobs.length === 0) return null;
  const hasFailed = jobs.some(j => j.status === 'failed' || j.status === 'cancelled');
  const hasProcessing = jobs.some(j => j.status === 'processing' || j.status === 'queued' || j.status === 'pending');
  const allCompleted = jobs.length > 0 && jobs.every(j => j.status === 'completed');
  if (hasFailed) return 'failed';
  if (hasProcessing) return 'processing';
  if (allCompleted) return 'completed';
  return 'processing';
}

export function buildOrderViewModel(order, jobsForOrder = []) {
  const totalJobs = jobsForOrder.length;
  const completedJobs = jobsForOrder.filter(j => j.status === 'completed').length;
  const completionRate = totalJobs > 0 ? Math.round((completedJobs / totalJobs) * 100) : 0;
  const totalCost = jobsForOrder.reduce((s, j) => s + (j.actualCost || 0), 0);
  const status = aggregateStatusFromJobs(jobsForOrder);

  const providersRaw = Array.isArray(order?.providers) ? order.providers : [];
  const providers = providersRaw.map(p => getProviderInfo(p.providerId || p.id || p)).filter(Boolean);

  const id = order?.id || '';
  const label = order?.orderName || (id ? `Order ${String(id).slice(-8)}` : 'Order');
  const createdAt = order?.createdAt?.toDate?.() || order?.createdAt || null;
  const requestedBy = order?.requestedBy || null;

  return {
    id,
    label,
    status,
    stats: { totalJobs, completedJobs, completionRate, totalCost },
    providers,
    meta: { createdAt, requestedBy }
  };
}


